// @core/api/endpoints/workflow/diff_pipeline_versions.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DiffPipelineVersionsResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Diff pipeline versions
 * Compares two pipeline versions, showing added/removed/modified nodes and connections.
 */
export async function DiffPipelineVersions(
  version_id: string,
  compare_version_id: string,
  options?: RequestOptions
): Promise<DiffPipelineVersionsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/versions/:version_id/diff/:compare_version_id`;
  requestPath = requestPath.replace(':version_id', encodeURIComponent(version_id));
  requestPath = requestPath.replace(':compare_version_id', encodeURIComponent(compare_version_id));
  const requestOptions = options;
  return client.get<DiffPipelineVersionsResponse>(requestPath, { ...requestOptions });
}
